/** @jsxImportSource @emotion/react */
import { Button, DialogActions, DialogContent, Divider, Grid, Snackbar, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useContext, useState } from 'react';
import ElevatedGrid from '../../Components/ElevatedGrid';
import { Il8nContext } from '../../Helper/i18n';
import PageLayout from '../Layout/PageLayout';
import { useEffect } from 'react';
import { StyledTextField } from '../../Components/CustomTextfield';
import MySnackbarContentWrapper from '../../Components/Snackbars';
import config from '../../config';
import axios from '../../Helper/Axios/interceptor';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { detailChecker, steps, getGlobalSteper } from '../../Helper/AppStepperData';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { getToken } from '../../Helper/Cookies/cookies';
import Popup, { PopupTitle } from '../../Components/CustomPopup';
import { updateStepper } from '../../Helper/Redux/reducers/upDown';
import FullScreenLoader from '../../Components/FullScreenLoader';

function Payment(props) {
    const theme = useTheme();
    const store = useSelector(state => state.storeState.stage)
    const stepper = useSelector(state => state.storeState.stepper)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [responseStatus, setResponseStatus] = useState({})
    const [customMargin, setCustomMargin] = useState()
    const [brokerageDetails, setBrokerageDetails] = useState({})
    const [includeMargin, setIncludeMargin] = useState(true)
    const [openTransactionStatusPopup, setOpenTransactionStatusPopup] = useState(false)
    const [isTransactionSuccessful, setIsTransactionSuccessful] = useState(false)
    const [paymentDone, setPaymentDone] = useState(false)
    const [loading, setLoading] = useState(false);
    const localeText = useContext(Il8nContext)

    useEffect(() => {
        getStageDetails()
    }, [])

    function handleSnackBarClose() {
        setSnackBarOpen(false)
        setResponseStatus()
    }

    const getStageDetails = () => {
        setLoading(true)
        axios.get(process.env.REACT_APP_API_URL + config.stageDetails)
            .then(resp => {
                if (resp.data.success) {
                    !(stepper?.length) && dispatch(updateStepper(getGlobalSteper(resp.data.success.stageDetilasList)))
                    getBrokerageDetails(resp.data.success.stageDetilasList)
                } else {
                    throw new Error()
                }
            }).catch((err) => {
                getBrokerageDetails()
                console.log(err.message)
            })
    }

    const getBrokerageDetails = (stagingData)=>{
        axios.get(process.env.REACT_APP_API_URL+config.getBrokerageDetails)
        .then(resp=>{
            if(resp.data.success){
                setLoading(false)
                setBrokerageDetails(resp.data.success[0])
                setCustomMargin(resp.data.success[0]?.marginAmount)
                if(detailChecker(stagingData, 8)){
                    setPaymentDone(true)
                }
                if(localStorage.getItem("payment")){
                    if(localStorage.getItem("payment")=="true"){
                        localStorage.removeItem("payment")
                        setIsTransactionSuccessful(true)                        
                    }else{
                        localStorage.removeItem("payment")
                        setIsTransactionSuccessful(false)
                        
                    }
                    toggleTransactionStatusPopup()
                }
            }
            else{
                throw new Error(resp.data.error)
            }
        })
        .catch(err=>{
            setLoading(false)
            console.log(err.message)
        })
    }

    const calculatePrice=()=>{
        let margin=includeMargin?(Number((brokerageDetails?.variableMarginAmount ? customMargin : brokerageDetails.marginAmount)||0)):0
        let fee=Number(brokerageDetails.processingFees)
        let discount= 0
        // if(promoSelected &&promoSelected.isDeduct){
        //     discount=promoSelected.amount100
        // }
        return margin+fee-discount
    }

    const makePayment = () => {
        var form = document.createElement("form")
        form.enctype = "application/form-url-encoded"
        form.method = "post"
        form.action = process.env.REACT_APP_PAYMENT_GATEWAY_URL
        var tk = getToken(true)
        var client = JSON.parse(atob(tk.split(".")[1]))
        var fieldsNValue = [
            /* {field:"payTypeCode",value:"PROFEE"},
            {field:"responseURL",value:window.location.href},
            {field:"channel",value:"WEB"},
            {field:"product",value:"DIY"},
            {field:"clientName",value:"clientName"},
            {field:"amount",value:calculatePrice()},
            {field:"mobile",value:"675676456"},
            {field:"email",value:"abc@asdfsd.com"},
            {field:"clientRequestID",value:"1"},
            {field:"payDescription",value:"Processing Fee for DIY"}, */
            { field: "panNo", value: brokerageDetails.pan },
            { field: "amount", value: calculatePrice() },
            { field: "email", value: brokerageDetails.email },
            { field: "purpose", value: "DIY" },
            { field: "clientCode", value: client.regRefNo }
        ]
        for (var i of fieldsNValue) {
            var inp = document.createElement("input")
            inp.name = i.field
            inp.value = i.value
            inp.type = "hidden"
            form.appendChild(inp);
        }
        document.body.appendChild(form)
        localStorage.setItem("payment", JSON.stringify(fieldsNValue));
        form.submit();
    }

    const nextNavigation = ()=>{
        dispatch(updateStepper({ step: 3, nestedStep: 3 }));
        navigate("/Upload")
    }

    const toggleTransactionStatusPopup = () => {
        setOpenTransactionStatusPopup(!openTransactionStatusPopup)
    }

    return (
        <>
            <PageLayout css={{ overflowY: "scroll" }} showSidebar calculateHeight={isSmallScreen ? true : false}
                breadcrumb={{ show: true, steps: steps[2].nestedSteps, step: 3, nestedStep: 3 }}>
                <ElevatedGrid >
                    <Grid container item alignItems={"start"} spacing={2}>
                        {paymentDone && <Grid item xs={12}>
                            <Typography css={{
                                "color": "white",
                                "text-align": "center",
                                "background": "#1DA838",
                                "border-radius": "5px",
                                "padding": "10px 0px",
                                "font-size": "16px",
                                "width": "100%",
                                "border": "#1DA838 1px solid",
                                "margin-bottom": "10px"
                            }}>
                                {localeText?.paymentAlreadyDone}
                            </Typography>
                        </Grid>}
                        <Grid item alignItems={"center"}>
                            <Typography fontSize={"24px"} fontWeight={"bold"} color="#525D72">
                                {localeText?.paymentType}
                            </Typography>
                        </Grid>
                        <Grid container item spacing={3}>
                            <Grid item xs={12} css={{ marginTop: "5px" }}>
                                <Typography variant="body1" css={{fontWeight:"bold"}} >
                                    {localeText?.paymentMarginAmountOnline}
                                </Typography>
                            </Grid>
                            <Grid container item xs={12} md={5} spacing={1}>
                                <Grid item xs={6} css={{ marginTop: "5px" }}>
                                    <Typography variant="body1" display={"inline"} color="#0098B0" css={{margin:"0px 10px"}} >
                                        {localeText?.paymentMarginAmount}
                                    </Typography>
                                    {includeMargin ? 
                                        <img css={{height:"20px", width:"20px", verticalAlign:"middle", cursor:"pointer"}} onClick={()=>setIncludeMargin(!includeMargin)}
                                            src={"/images/icon-close-circle.svg"} 
                                        />
                                        :
                                        <AddCircleIcon css={{height:"20px", width:"20px", color:"green", verticalAlign:"middle", cursor:"pointer"}} onClick={()=>setIncludeMargin(!includeMargin)} />
                                    }
                                </Grid>
                                <Grid item xs={6} css={{ marginTop: "5px" }}>
                                    {brokerageDetails?.variableMarginAmount ?
                                        <StyledTextField css={{ float: "right" }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            value={customMargin}
                                            error={customMargin && ((customMargin < brokerageDetails.marginAmount) || (customMargin > brokerageDetails.maxMarginAmount))}
                                            helperText={customMargin && ((customMargin < brokerageDetails.marginAmount) || (customMargin > brokerageDetails.maxMarginAmount)) && 
                                                `${localeText?.paymentMargin} ${brokerageDetails.marginAmount} ${localeText?.paymentAnd} ${brokerageDetails.maxMarginAmount}`} 
                                            fullWidth
                                            variant="standard"
                                            onChange={(e) => { setCustomMargin(e.currentTarget.value) }}
                                        />
                                        :
                                        <Typography variant="body1" css={{ float: "right", fontWeight: "bolder", marginRight: "10px", textDecoration: !includeMargin ? "line-through red 2px" : "none" }}>
                                            {brokerageDetails?.marginAmount && ("₹ "+ brokerageDetails?.marginAmount)}
                                        </Typography>
                                    }
                                </Grid>
                                <Grid item xs={12} css={{ marginTop: "5px" }}>
                                    <Divider css={{borderColor : "lightgrey"}} />
                                </Grid>
                                <Grid item xs={6} css={{ marginTop: "5px" }}>
                                    <Typography variant="body1" color="#0098B0" css={{marginLeft:"10px"}} >
                                        {localeText?.paymentProcessingFee}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6} css={{ marginTop: "5px" }}>
                                    <Typography variant="body1" css={{float: "right", fontWeight: "bolder", marginRight:"10px"}}>
                                        {"₹ "+brokerageDetails?.processingFees}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} css={{ marginTop: "5px" }}>
                                    <Divider css={{borderColor : "black"}} />
                                </Grid>
                                <Grid item xs={6} css={{ marginTop: "5px" }}>
                                    <Typography variant="body1" color="#0098B0" css={{fontWeight:"bold", marginLeft:"10px"}}>
                                        {localeText?.paymentTotal}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6} css={{ marginTop: "5px" }}>
                                    <Typography variant="body1" css={{float: "right", fontWeight: "bolder", marginRight:"10px"}}>
                                        {`₹ ${calculatePrice()}`}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={8} css={{ marginTop: "5px" }}>
                                <Typography variant="body2">
                                    {localeText?.paymentDone} <b>{localeText?.paymentCompleted}</b>{localeText?.paymentMessage}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid item xs={4} md={2} css={{ marginTop: "40px" }}>
                            <Button variant='contained' color="primary" css={{width: "100%"}} onClick={nextNavigation}>
                                {paymentDone ? localeText?.bankDetailsNextBtn : localeText?.paymentSkip}
                            </Button>
                        </Grid>
                        {!paymentDone && <Grid item xs={4} md={2} css={{ marginTop: "40px" }}>
                            <Button variant='contained' disabled={(brokerageDetails?.variableMarginAmount && customMargin && ((customMargin < brokerageDetails.marginAmount) || (customMargin > brokerageDetails.maxMarginAmount))) || !includeMargin} 
                                color="primary" css={{width: "100%"}} onClick={makePayment}>
                                {localeText?.bankDetailsNextBtn}
                            </Button>
                        </Grid>}
                    </Grid>
                </ElevatedGrid>
            </PageLayout>
            <Popup
                open={openTransactionStatusPopup}
                maxWidth={"sm"}
            >
                <PopupTitle onClose={toggleTransactionStatusPopup} />
                <DialogContent css={{ textAlign: "center", margin: "0px 30px" }}>
                    <img src="images/icon_digilocker_popup.svg" alt="icon_digilocker_popup" css={{ marginBottom: "20px" }} />
                    <Typography>
                        {isTransactionSuccessful ? localeText?.paymentTransactionCompleted : localeText?.paymentTransactionFailed}
                    </Typography>
                    <Button variant="contained" color="primary" css={{ margin: "25px" }} onClick={isTransactionSuccessful ? nextNavigation : toggleTransactionStatusPopup} >
                       {localeText?.paymentOkay}
                    </Button>
                </DialogContent>
                <DialogActions>
                </DialogActions>
            </Popup>
            {
                responseStatus && responseStatus.message && <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackBarOpen}
                    autoHideDuration={5000}
                    onClose={handleSnackBarClose}
                >
                    <MySnackbarContentWrapper
                        onClose={handleSnackBarClose}
                        variant={responseStatus.type}
                        message={responseStatus.message}
                    />
                </Snackbar>
            }
        </>
    );
}

export default Payment;
